import { css } from '@styles/theme'

export const Activitytyles = {
	container: css({
		background: '$neutral30',
		padding: '21px',
		width: '100%',

		'&.AccordionTrigger': {
			color: 'red',
		},

		'@sm': {
			padding: '8px 65px 8px 61px',
		},
	}),
	titleIndex: css({
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		marginTop: '40px',
		marginBottom: '41px',

		div: {
			display: 'flex',
			gap: '5px',
			marginTop: '10px',
			flexDirection: 'column-reverse',
		},

		'@md': {
			flexDirection: 'row',

			div: {
				display: 'flex',
				gap: '28px',
				marginTop: '0px',
				flexDirection: 'row',
			},
		},
	}),

	title: css({
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		marginTop: '19px',
		marginBottom: '32px',

		div: {
			display: 'flex',
			gap: '5px',
			marginTop: '10px',
			flexDirection: 'column-reverse',
		},

		'@md': {
			flexDirection: 'row',

			div: {
				display: 'flex',
				gap: '28px',
				marginTop: '0px',
				flexDirection: 'row',
			},
		},
	}),
}
